<template>
  <section
    :class="hasBorder ? 'error-handler error-handler__border' : 'error-handler'"
  >
    <div class="error-handler__status">
      <div :class="statusClasses">
        <BaseIcon :icon="icon" />
      </div>
    </div>

    <div class="error-handler__content">
      <BaseText class="error-handler__content-title" size="md">
        {{ title }}
      </BaseText>

      <BaseText
        v-if="description"
        :color="NebraskaColors.textSecondary"
        class="error-handler__content-description"
        size="sm"
      >
        {{ description }}
      </BaseText>

      <ButtonSecondary
        v-if="showButton"
        data-testid="error-handler-button"
        class="error-handler__content-button"
        :label="label"
        @click="retry"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import {
  Heading,
  BaseIcon,
  BaseText,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

enum ErrorHandlerStatus {
  WARNING = 'warning'
}

@Component({
  name: 'ErrorHandler',
  components: { Heading, BaseIcon, BaseText, ButtonSecondary }
})
export default class ErrorHandler extends Vue {
  public readonly NebraskaColors = NebraskaColors;

  @Prop({ required: true, type: String })
  public readonly title!: string;

  @Prop({ required: false, type: String })
  public readonly description?: string;

  @Prop({ required: false, type: String, default: ErrorHandlerStatus.WARNING })
  public readonly status?: ErrorHandlerStatus;

  @Prop({ default: 'Tentar novamente', type: String })
  public readonly label!: string;

  @Prop({ default: true, type: Boolean })
  public readonly showButton!: boolean;

  @Prop({ type: String, default: 'ic_attention' })
  public readonly icon!: string;

  @Prop({ type: Boolean, default: true })
  public readonly hasBorder!: boolean;

  @Emit('retry')
  public retry() {}

  get statusClasses(): string[] {
    return [
      'error-handler__status-icon',
      `error-handler__status--${this.status}`
    ];
  }
}
</script>

<style lang="less" scoped>
.error-handler {
  display: flex;
  width: 100%;
  padding: @size-spacing-x500;
  gap: @size-spacing-x350;
  border-radius: @size-radius-x200;

  &__border {
    border: @size-border-x400 solid @divider-primary;
  }

  &__status {
    display: flex;
    align-items: center;
    justify-content: center;

    &--warning {
      background-color: @status-alert-background;
    }

    &-icon {
      margin-bottom: @size-spacing-x400;
      border-radius: @size-radius-max;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 48px;
      width: 48px;
    }
  }

  &__content {
    &-title {
      margin-left: @size-spacing-x350;
      font-weight: 700;
    }

    &-description {
      margin: @size-spacing-x150 0 0 @size-spacing-x350;
    }

    &-button {
      margin-top: @size-spacing-x400;
    }
  }
}
</style>
